module.exports = __webpack_public_path__ + "static/media/006.33a250bf.jpg";